import { createContext } from "react";
import type { TickerContentDataType, TickerDataType } from "../../types/widgets";

interface TickerContextType {
  tickerData: TickerContentDataType[];
  setTickerData: (data: TickerContentDataType[]) => void;
  // Legacy: Add ticker data from dashboard response
  addToTickerContext: (tickerData: TickerDataType[]) => void;
  // New: Add ticker data from independent ticker query
  addFromTickerQuery: (tickerData: TickerDataType[]) => void;
  // New: Set loading state for independent ticker query
  setTickerLoading: (loading: boolean) => void;
  // New: Reset ticker state (when switching dashboards)
  resetTickerState: () => void;
  // New: Loading state
  isLoading: boolean;
  // New: Whether independent query is being used
  useIndependentQuery: boolean;
}

export const TickerContext = createContext<TickerContextType | undefined>(undefined);

export default TickerContext;
